module.exports = __webpack_public_path__ + "img/rock-big-01.12bf934e.png";